import keyEventDispatcher from '../consumer/key-event-dispatcher';
import stringToBoolean from '../utils/string-to-boolean';

const KEYEVENT_MESSAGE = 'ws:keyevent';

const keyEventMessageHandler = (event) => {
  const { data } = event;

  if (typeof data === 'string' && data.startsWith(`${KEYEVENT_MESSAGE} `)) {
    const [, bubbles, cancelable, key, keyCode, ctrlKey, altKey, metaKey, shiftKey] =
      data.split(' ');

    const keyEvent = {
      altKey: stringToBoolean(altKey),
      bubbles: stringToBoolean(bubbles),
      cancelable: stringToBoolean(cancelable),
      ctrlKey: stringToBoolean(ctrlKey),
      key,
      keyCode,
      metaKey: stringToBoolean(metaKey),
      shiftKey: stringToBoolean(shiftKey),
    };

    keyEventDispatcher(keyEvent);
  }
};

export default keyEventMessageHandler;
